import { Component, forwardRef, Input, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { BtFilePickerModel } from '../bt-file-picker.model';

@Component({
    selector: 'bt-file-picker-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => BtFilePickerFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => BtFilePickerFormComponent),
        multi: true
      }
    ],
    templateUrl: './bt-file-picker-form.component.html',
    styleUrls: ['./bt-file-picker-form.component.scss']
})
export class BtFilePickerFormComponent implements ControlValueAccessor {
    @Input() model: BtFilePickerModel;
    @Input() value: any;

    constructor(private cdf: ChangeDetectorRef) {}

    propagateChange = (_: any) => {};
    registerOnChange(fn: any) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: string) {
        this.value = value; 
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

  onFileChanged(event: any) {
      var reader = new FileReader();
      reader.onload = () => {
        this.value = reader.result + "";
        this.propagateChange(this.value);
        this.cdf.detectChanges();
      };
      reader.readAsDataURL(event.target.files[0]);
  }
}